
import { useState } from "react";
import { Button } from "./ui/button";
import { Dialog, DialogContent, DialogTitle, DialogTrigger } from "./ui/dialog";
import DomainForm from "./DomainForm";
import { DomainFormSchema } from "@/schemas/domain-form.schema";
import { z } from "zod";
import { DomainSchema } from "@/schemas/domain.schema";
import { addDomain } from "@/services/domains.service";

interface Props {
    companyId: string
    onAddSuccess?: (domain: z.infer<typeof DomainSchema>) => void
}


export default function AddDomainModal(props: Props) {
    const [open, setOpen] = useState(false)
    const [isLoading, setIsLoading] = useState(false)

    const handleOnSubmit = async (data: z.infer<typeof DomainFormSchema>) => {
        try {
            setIsLoading(true);

            const domain = await addDomain(props.companyId, data);
            handleSuccess(domain);
        } catch (error) {
            console.log(error);
            setIsLoading(false);
        }
    }

    const handleSuccess = (domain: z.infer<typeof DomainSchema>) => {
        setIsLoading(false);
        setOpen(false);
        props.onAddSuccess?.(domain);
    }

    return (
        <Dialog open={open} onOpenChange={setOpen}>
            <DialogTrigger asChild>
                <Button>Add Domain</Button>
            </DialogTrigger>
            <DialogContent className="max-w-xl w-xl">
                <DialogTitle>Add Domain</DialogTitle>

                <DomainForm companyId={props.companyId} onSubmit={handleOnSubmit} isLoading={isLoading} />
            </DialogContent>
        </Dialog>
    )
}